<style lang="less" scoped>
  .hex__remove{
    color: #fff;
    width: 16px;
    height: 16px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    font-weight: 500;
    cursor: pointer;
  }
  .close {
    font-size: 14px;
    color: #959595;
  }
</style>
<template>
  <div @click="confirm" v-if="!tooltip" class="hex__remove">
    <a-icon class="close" type="close" />
  </div>
  <a-popconfirm  class="hex__remove" v-else placement="rightTop" okText="确认" cancelText="取消" @confirm="confirm">
    <template slot="title">
      <p>删除当前功能?</p>
    </template>
    <a-icon class="close" type="close" />
  </a-popconfirm>
</template>
<script>
export default {
  name: 'remove',
  props: {
    tooltip: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    confirm () {
      this.$emit('delete')
    }
  }
}
</script>
